import type { Point } from '../stage';

/** A seat's action bubble, centred on the layout's bubble point for the seat's position. */
export function SeatBubble({ text, at }: { text: string; at: Point }) {
  return <span key={text} className="seat-bubble" style={{ left: at.x, top: at.y }} data-testid="bubble">{text}</span>;
}
